var exports = {
  "kL": "x43aef4ae--8ace23--container",
  "C0": "x43aef4ae--8ace23--container--right",
  "UE": "x43aef4ae--8ace23--arrow",
  "PG": "x43aef4ae--8ace23--container--left",
};

module.exports = exports;
